import styled from "styled-components";

export const Group = styled.g``